import React from 'react';
import Children from '../../interfaces/children.interface';
import TestId from '../../interfaces/test-id.interface';

interface Props extends Children, TestId {
  /** The layout's type (centered = full width / app = menu, header & content) */
  type: 'centered' | 'app';

  /** The menu to render on the left (only in `type = app`) */
  menu?: React.ReactNode;

  /** The header to render on top (only in `type = app`) */
  header?: React.ReactNode;
}

/** Container to enclose various contents */
const Layout = ({ children, type, header, menu, testId }: Props): React.ReactElement => (
  <div className={`layout--${type}`} data-testid={testId}>
    {type === 'app' ? <div className="layout__header">{header}</div> : ''}
    {type === 'app' ? <div className="layout__menu">{menu}</div> : ''}
    <div className="layout__content">
      {type === 'centered' ? (
        <img
          style={{
            position: 'absolute',
            top: '10%',
            left: '45%',
            zIndex: -1,
            transform: 'translateX(-50%)',
          }}
          src="/assets/img/network.svg"
          alt="Network"
        />
      ) : null}
      {children}
    </div>
  </div>
);

export default Layout;
